import React, {FC} from 'react'
import { Link } from 'react-router-dom';
import {useLang} from "../../hooks/useLang";

const LanguageSelector: FC = props => {
    const { t, lang, changeLanguage } = useLang();

    const onChangeLanguage = (flag) => {
        changeLanguage(flag);
    }

    return (
        <button
            type="button"
            className="language-link"
            onClick={() => onChangeLanguage((lang === 'bn') ? "en" : "bn")}
            aria-label={(lang === 'bn') ? "SeeIn English" : "See in Bengali"}
        >
            {(lang === 'bn') ? "In English" : "বাংলায় দেখুন"}
        </button>
    )
}

export default React.memo(LanguageSelector);
